<template>
  <div>
    <div
      class="landing-page-search-content landing-page-search-content_first"
    >
      <selectWithKeyTemplate
        :settings="countrySelectSettings"
        @changeSelect="selectCountry($event)"
      />
    </div>
  </div>
</template>

<script>
import selectWithKeyTemplate from '@/components/fields/selectWithKeyTemplate';
import { sortBy } from 'lodash';

export default {
  name: 'StepFirst',
  components: {
    selectWithKeyTemplate,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    activeCountry: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      activeSlide: 0,
    };
  },
  computed: {
    selectCountriesList() {
      const newArr = [];
      if (this.createdCountriesList) {
        this.createdCountriesList.forEach((item) => {
          newArr.push({
            text: item.name[this.language],
            key: item._id,
            code: item.code,
            image: `country/${item.code}.svg`,
          });
        });
      }
      return newArr;
    },
    countrySelectSettings() {
      return {
        optionList: this.selectCountriesList,
        placeholderText: this.$t('countryPage.placeholderSelect'),
        selectedKey: this.activeCountry,
        disable: false,
        toTop: false,
        tabindex: 1,
        selectClass: 'select_alt',
        imagePosition: 'left',
        showImageInput: true,
      };
    },
    createdCountriesList() {
      if (this.items.length) {
        return sortBy(this.items, `name.${this.language}`);
      }
      return [];
    },
    language() {
      return this.$i18n.locale;
    },
  },
  methods: {
    selectedCountry() {
      this.$emit('selectedCountry');
      this.$emit('conditionStep', false);
    },
    selectCountry(id) {
      this.$emit('selectCountry', id);
      this.selectedCountry();
    },
    getOptionImage(image) {
      try {
        /* eslint-disable */
        return require(`@/assets/images/country/${image}.svg`);
        /* eslint-enable */
      } catch (error) {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../sass/variables";
@import "../../../sass/mixins";

  .landing-page-search {

    &-content {

      &__wrapper {
        max-width: 56px;
        min-width: 56px;
        font-size: 0;

        img {
          border-radius: 50%;
        }
      }

      &__slider {
        cursor: pointer;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        min-width: 130px;
        padding: 0 15px;
        transition: all .15s ease-in;

        &-text {
          font: $font-size-sm $font-landing-global;
          color: $color-silver-chalice;
          text-align: center;
          margin-top: 6px;

          &_active {
            color: $color-dodger-blue;
            font: $font-size-base $font-landing-global;
          }
        }
      }
    }

    &-btn {
      display: flex;
      justify-content: flex-end;
      margin-top: 57px;

      button {
        height: 53px;
        padding: 0 30px;
        border-radius: 0;
      }

      &_disable {
        border-color: $color-silver-chalice;
        pointer-events: none;
        color: rgba($color-white, .4);
      }

      &_margin {
        margin-top: 40px;
      }
    }
  }

  @include tablet-portrait {
    .landing-page-search {
      &-content {
        display: flex;
        justify-content: center;
      }
    }
  }

  @include mobile {
    .landing-page-search {
      &-content {
        min-height: auto;
        margin-left: 0;
        margin-right: 0;
        max-width: 100% !important;
      }

      &-btn {
        margin-top: 89px;

        button {
          margin: auto;
        }
      }
    }
  }
</style>
